<div [ngClass]="{'sidebarnormal': isNormal(), 'sidebarsmall': isSmall()}">
  <mat-toolbar class="headtoolbar" color="primary">
    <div fxLayout="row" class="w-100 lnk" *ngIf="isSmall()" fxLayoutAlign="center center">
      <img routerLink="/admin" src="assets/images/logo-mini-new.svg" width="32" alt="Logo Mini"/>
    </div>
    <div fxLayout="row" class="w-100 lnk" *ngIf="isNormal()" fxLayoutAlign="center center">
      <img routerLink="/admin" src="assets/images/logo.svg" width="170" alt="Logo"/>
    </div>
  </mat-toolbar>
  <mat-nav-list color="primary" class="nav-list-container">
    <ng-container *ngFor="let menu of adminMenus">
      <div *ngIf="menu.show && !menu.isSubMenu" class="itemlist" [ngClass]="{'active': getActive(menu)}">
        <div *ngIf="menu.subMenus; else singleMenu" (click)="toggleMenu(menu)" class="nav-link" matTooltip="{{menu.title}}" matTooltipPosition="right" matTooltipClass="custom-tooltip">
          <mat-icon *ngIf="menu.icon" svgIcon="{{menu.icon}}"></mat-icon>
          <div class="menu-text" *ngIf="isNormal()">{{menu.title}}</div>
          <mat-icon class="chevron" *ngIf="isNormal() && menu.subMenus" [ngClass]="{'chevron-down': !menu.isExpanded, 'chevron-up': menu.isExpanded}">
            {{ menu.isExpanded ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </div>
        <ng-template #singleMenu>
          <a [routerLink]="menu.url" class="nav-link">
            <mat-icon *ngIf="menu.icon" svgIcon="{{menu.icon}}" [ngClass]="{'itemlist-deletion': menu.title == 'Attribute Data Deletion'}"></mat-icon>
            <div class="menu-text" *ngIf="isNormal()">{{menu.title}}</div>
          </a>
        </ng-template>
        <mat-expansion-panel *ngIf="menu.subMenus && menu.isExpanded" [expanded]="menu.isExpanded" hideToggle class="submenu-panel">
          <mat-nav-list class="sub-menu-list">
            <ng-container *ngFor="let subMenu of menu.subMenus">
              <div *ngIf="subMenu.show" class="itemlist sub-menu" [ngClass]="{'active': getActive(subMenu)}" matTooltip="{{subMenu.title}}" matTooltipPosition="right" matTooltipClass="custom-tooltip" [routerLink]="subMenu.url">
                <div class="sub-menu-item">
                  <mat-icon *ngIf="subMenu.icon" svgIcon="{{subMenu.icon}}" [ngClass]="{'itemlist-deletion': subMenu.title == 'Attribute Data Deletion'}"></mat-icon>
                  <div class="menu-text sub-menu-text" *ngIf="isNormal()">{{subMenu.title}}</div>
                </div>
              </div>
            </ng-container>
          </mat-nav-list>
        </mat-expansion-panel>
      </div>
    </ng-container>
  </mat-nav-list>
</div>